export default "__VITE_ASSET__28d6a1a0__"